"use strict";
exports.__esModule = true;
exports.isDesktopVersion = exports.isMobileVersion = exports.checkMobile = exports.deleteCookie = exports.setCookie = exports.baseUrl = exports.getDocumentId = exports.getUserFlag = void 0;
/*
* @returns type of document: true if user, false if internal
*/
var getUserFlag = function () {
    var url = new URL(window.location.href);
    var pathname = url.pathname;
    try {
        var isUser = pathname.match(/(\/user-edit\/)/)[1];
        if (isUser === '/user-edit/') {
            return true;
        }
        return false;
    }
    catch (_a) {
        return false;
    }
};
exports.getUserFlag = getUserFlag;
/**
 * @returns id of document
 */
var getDocumentId = function () {
    var url = new URL(window.location.href);
    var pathname = url.pathname;
    try {
        var documentId = pathname.match(/([0-9]+)\/?$/)[1];
        return Number(documentId);
    }
    catch (_a) {
        return 0;
    }
};
exports.getDocumentId = getDocumentId;
/**
 * @param node_env
 */
var getBaseUrl = function (node_env) {
    if (!node_env || node_env === 'development') {
        return 'https://devapi.templateroller.com';
    }
    return 'https://api.templateroller.com';
};
exports.baseUrl = getBaseUrl(process.env.REACT_APP_ENV);
function setCookie(name) {
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + ("1") + expires + "; path=/";
}
exports.setCookie = setCookie;
function deleteCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
exports.deleteCookie = deleteCookie;
function checkMobile() {
    if (navigator.userAgent.match(/mobile/im)) {
        deleteCookie('desktop');
        setCookie('mobile');
        return true;
    }
    deleteCookie('mobile');
    setCookie('desktop');
    return false;
}
exports.checkMobile = checkMobile;
var isMobileVersion = function () {
    var value_or_null = (document.cookie.match(/^(?:.*;)?\s*mobile\s*=\s*([^;]+)(?:.*)?$/) || [, null])[1];
    if (value_or_null === '1') {
        return true;
    }
    return false;
};
exports.isMobileVersion = isMobileVersion;
exports.isDesktopVersion = !exports.isMobileVersion();
